(self["webpackChunk"] = self["webpackChunk"] || []).push([[9868],{

/***/ 26379:
/***/ (() => {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const SCRIPT_TAG = 'script';
if (typeof window.isHubSpotLoaded === 'undefined') {
    window.isHubSpotLoaded = false;
}
function log(message) {
    if (RAILS_ENV === 'production') {
        return;
    }
    // eslint-disable-next-line no-console
    console.log(message);
}
function identify() {
    if (window.currentUser) {
        log('Identifying user with HubSpot');
        var _hsq = window._hsq = window._hsq || [];
        _hsq.push([
            'identify',
            {
                email: window.currentUser.email,
                id: window.currentUser.id,
                qc_subscription_api: window.currentUser.subscriptionStatus
            }
        ]);
    }
}
function startHubSpotScript() {
    return _startHubSpotScript.apply(this, arguments);
}
function _startHubSpotScript() {
    _startHubSpotScript = _async_to_generator(function*(id = 'hs-script-loader', src = '//js.hs-scripts.com/44326808.js') {
        return new Promise((resolve, reject)=>{
            const lastScriptElement = document.getElementsByTagName(SCRIPT_TAG)[0];
            const scriptElement = document.createElement(SCRIPT_TAG);
            scriptElement.type = 'text/javascript';
            scriptElement.async = true;
            scriptElement.id = id;
            scriptElement.onload = ()=>resolve();
            scriptElement.onerror = (error)=>reject(error);
            scriptElement.src = src;
            lastScriptElement.parentNode.insertBefore(scriptElement, lastScriptElement);
        });
    });
    return _startHubSpotScript.apply(this, arguments);
}
function bindTurbolinks() {
    document.addEventListener('turbolinks:load', ()=>{
        log('Tracking Hubspot page view with turbolinks:load event');
        identify();
        var _hsq = window._hsq = window._hsq || [];
        _hsq.push([
            'setPath',
            location.pathname + location.search
        ]);
        _hsq.push([
            'trackPageView'
        ]);
        startHubSpotScript().then(()=>{
            log('HubSpot script reloaded');
        });
    });
    document.addEventListener('turbolinks:before-visit', ()=>{
        const webInteractiveEmbed = 'script[src="https://js.hubspot.com/web-interactives-embed.js"]';
        const el = document.querySelector(webInteractiveEmbed);
        if (el) {
            window.hubspot_web_interactives_running = false;
            el.remove();
            log('Removing web-interactives-embed.js script tag');
        }
        const hsScript = 'script[src="//js.hs-scripts.com/44326808.js"]';
        const el2 = document.querySelector(hsScript);
        if (el2) {
            window.hubspot_web_interactives_running = false;
            el2.remove();
            log('Removing hs-scripts.com script tag');
        }
    });
}
function onLoaded() {
    window.isHubSpotLoaded = true;
    log('HubSpot loaded');
    identify();
    bindTurbolinks();
}
if (!window.isHubSpotLoaded) {
    Promise.all([
        startHubSpotScript()
    ].filter(Boolean)).then(()=>onLoaded()).catch((err)=>Rollbar.error('Erro ao inicializar HubSpot', err));
}


/***/ }),

/***/ 87586:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

;// CONCATENATED MODULE: ./utils/trackers/gtm.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const LAYER_NAME = 'dataLayer';
const SCRIPT_TAG = 'script';
if (typeof window.isGTMStarted === 'undefined') {
    window.isGTMStarted = false;
}
function ensureLayer() {
    window[LAYER_NAME] = window[LAYER_NAME] || [];
}
function notifyPageView() {
    ensureLayer();
    let { pathname, search } = window.location;
    if (pathname.charAt(0) === '/') {
        pathname = pathname.substr(1);
    }
    window['dataLayer'].push({
        event: 'pageView',
        virtualUrl: pathname + search
    });
}
function bindTurbolinks() {
    document.addEventListener('turbolinks:load', ()=>notifyPageView());
}
function notifyGTMStartup() {
    window[LAYER_NAME].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    });
}
function onGTMLoaded() {
    notifyGTMStartup();
    bindTurbolinks();
    window.isGTMStarted = true;
}
function startGTM(code) {
    return _startGTM.apply(this, arguments);
}
function _startGTM() {
    _startGTM = _async_to_generator(function*(code) {
        return new Promise((resolve, reject)=>{
            ensureLayer();
            const lastScriptElement = document.getElementsByTagName(SCRIPT_TAG)[0];
            const scriptElement = document.createElement(SCRIPT_TAG);
            const params = LAYER_NAME !== 'dataLayer' ? '&l=' + LAYER_NAME : '';
            scriptElement.async = true;
            scriptElement.onload = ()=>resolve();
            scriptElement.onerror = (error)=>reject(error);
            scriptElement.src = 'https://www.googletagmanager.com/gtm.js?id=' + code + params;
            lastScriptElement.parentNode.insertBefore(scriptElement, lastScriptElement);
        });
    });
    return _startGTM.apply(this, arguments);
}
function startQCX() {
    return _startQCX.apply(this, arguments);
}
function _startQCX() {
    _startQCX = _async_to_generator(function*() {
        return startGTM(RAILS_ENV === 'production' ? 'GTM-NNF97JX' : 'GTM-NPDX48V');
    });
    return _startQCX.apply(this, arguments);
}
if (!window.isGTMStarted && (RAILS_ENV === 'staging' || RAILS_ENV === 'production')) {
    Promise.all([
        startQCX()
    ].filter(Boolean)).then(()=>onGTMLoaded())// eslint-disable-next-line no-console
    .catch((err)=>console.log('Erro ao inicializar GTM', err));
}

// EXTERNAL MODULE: ./utils/trackers/hubspot.js
var hubspot = __webpack_require__(26379);
// EXTERNAL MODULE: ./utils/trackers/zaraz.js
var zaraz = __webpack_require__(19394);
;// CONCATENATED MODULE: ./utils/trackers/index.js


// import './iterable';
// import './onesignal';
// import './userdotcom';
 // import './apm';
 // import './hotjar';


/***/ }),

/***/ 67375:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ../../node_modules/.pnpm/amplitude-js@8.17.0/node_modules/amplitude-js/amplitude.esm.js + 1 modules
var amplitude_esm = __webpack_require__(74693);
;// CONCATENATED MODULE: ./utils/trackers/user/amplitude_integration.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

const keys = {
    production: 'b2d6e37cf3d7d47ee2a50be7e1d29cec',
    staging: '9ff42464c29111a9a4586e2792e8375a',
    development: '13bb435405674380b8fe7b7739432d3f'
};
class AmplitudeIntegration {
    static emit(fn, params) {
        this[fn](params);
    }
    static setup() {
        if (this.ready) {
            return true;
        }
        amplitude_esm/* default.getInstance */.Z.getInstance().init(keys[RAILS_ENV], null, {
            includeUtm: true,
            includeGclid: true,
            includeFbclid: true,
            saveParamsReferrerOncePerSession: true,
            logAttributionCapturedEvent: true
        });
        this.identify();
        this.ready = true;
        return true;
    }
    static identify(extraParams = {}) {
        const { id, name, email, created_at, subscription, subscriptionExpireAt, segment, previousExperience, carrers, source_project, daysRemaining, totalDaysRemaining, daysSinceExpiration, lastSubscriptionLevel, recurrence, lastSubscriptionDuration, institution, jobPost, recurrenceSystem, recurrenceStatus, haveQcCourse, courseExpired, qcCourseExpiration, qcCourses, sequenceOfDays, longestSequenceOfDays } = this.getUserData();
        const experiments = this.getExperiments();
        const identify = new amplitude_esm/* default.Identify */.Z.Identify();
        identify.set('name', name).set('email', email).setOnce('created_at', created_at).set('subscription', subscription).set('subscription expire at', subscriptionExpireAt).set('segment', segment).set('previous experience', previousExperience).set('carrers', carrers).set('source_project', source_project).set('days remaining', daysRemaining).set('total days remaining', totalDaysRemaining).set('days since expiration', daysSinceExpiration).set('last subscription level', lastSubscriptionLevel).set('recurrence', recurrence).set('last subscription duration', lastSubscriptionDuration).set('institution', institution).set('job_post', jobPost).set('recurrence system', recurrenceSystem).set('recurrence status', recurrenceStatus).set('have qc course', haveQcCourse).set('course expired', courseExpired).set('qc course expiration', qcCourseExpiration).set('qc courses', qcCourses).set('study streak days', sequenceOfDays).set('maximum streak days', longestSequenceOfDays);
        Object.entries(extraParams).forEach(([key, val])=>{
            identify.set(key, val);
        });
        experiments == null ? void 0 : experiments.forEach((experiment)=>{
            identify.set(`experiment_${experiment.identifier}`, experiment.group);
        });
        amplitude_esm/* default.getInstance */.Z.getInstance().setUserId(id);
        amplitude_esm/* default.getInstance */.Z.getInstance().identify(identify);
    }
    static getUserData() {
        const user = window.jQuery('#js-current-user').get(0);
        if (!user) {
            return {
                id: null
            };
        }
        const { id, name, email, created_at, subscriptionStatus, subscriptionExpireAt, segment, previousExperience, carrers, daysRemaining, totalDaysRemaining, daysSinceExpiration, lastSubscriptionLevel, recurrence, lastSubscriptionDuration, institution, jobPost, recurrenceSystem, recurrenceStatus, haveQcCourse, courseExpired, qcCourseExpiration, qcCourses, sequenceOfDays, longestSequenceOfDays } = user.dataset;
        return {
            id,
            name,
            email,
            created_at,
            subscription: subscriptionStatus,
            subscriptionExpireAt,
            segment,
            previousExperience,
            carrers,
            source_project: gon.source_project,
            daysRemaining,
            totalDaysRemaining,
            daysSinceExpiration,
            lastSubscriptionLevel,
            recurrence: recurrence === 'active',
            lastSubscriptionDuration,
            institution,
            jobPost,
            recurrenceSystem,
            recurrenceStatus,
            haveQcCourse,
            courseExpired,
            qcCourseExpiration,
            qcCourses,
            sequenceOfDays,
            longestSequenceOfDays
        };
    }
    static getExperiments() {
        return gon.experiments;
    }
    static event({ eventName = 'default_1', data = {} }) {
        this.send(eventName, _extends({}, data, {
            source_project: gon.source_project
        }));
    }
    static pageVisited({ pageName = 'default_2', data = {} }) {
        this.send(`${pageName} visited`, data);
    }
    static productInteraction() {
        // We are preventing this event at this time { product_id = 0, event_type = 'view', data = {} }
        return;
    // this.send('Product visited', { product_id, event_type, ...data });
    }
    static send(key, params) {
        this.identify();
        amplitude_esm/* default.getInstance */.Z.getInstance().logEvent(key, params);
    }
}
AmplitudeIntegration.integrationName = 'amplitude';
AmplitudeIntegration.enabled = true;
AmplitudeIntegration.ready = false;
AmplitudeIntegration.retry = 0;


// EXTERNAL MODULE: ./utils/query_string/index.js
var query_string = __webpack_require__(48174);
;// CONCATENATED MODULE: ./utils/trackers/user/user_integration.js
function user_integration_extends() {
    user_integration_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return user_integration_extends.apply(this, arguments);
}
class UserIntegration {
    static setup() {
        return typeof window.userengage === 'function';
    }
    static emit(fn, params) {
        this[fn](params);
    }
    static event({ eventName = 'default_1', data = {} }) {
        this.send(`event.${eventName}`, data);
    }
    static pageVisited({ pageName = 'default_2', data = {} }) {
        this.send(`event.${pageName} visited`, data);
    }
    static productInteraction({ product_id = 0, event_type = 'view', data = {} }) {
        this.send('product_event', user_integration_extends({
            product_id,
            event_type
        }, data));
    }
    static send(key, params) {
        // eslint-disable-next-line no-undef
        window.userengage(key, params);
    }
}
UserIntegration.integrationName = 'user';
UserIntegration.enabled = true;
UserIntegration.retry = 0;


// EXTERNAL MODULE: ./utils/trackers/zaraz.js
var zaraz = __webpack_require__(19394);
;// CONCATENATED MODULE: ./utils/trackers/user/zaraz_integration.js
/* eslint-disable no-unused-vars */ 
class ZarazIntegration {
    static setup() {
        if (this.ready) {
            return true;
        }
        this.identify();
        this.ready = true;
        return true;
    }
    static identify() {
        const userData = this.getUserData();
        const { id, subscriptionStatus, email, segment, created_at, previousExperience } = this.getUserData();
        if (!id) {
            return;
        }
        zaraz/* default.set */.Z.set('userId', id);
        zaraz/* default.set */.Z.set('user_subscription', subscriptionStatus);
        zaraz/* default.set */.Z.set('email', email);
        zaraz/* default.set */.Z.set('segment', segment);
        zaraz/* default.set */.Z.set('created_at', created_at);
        zaraz/* default.set */.Z.set('previous_experience', previousExperience);
        if (previousExperience) {
            zaraz/* default.set */.Z.set('previous_experience', previousExperience);
        }
    }
    static getUserData() {
        const user = window.jQuery('#js-current-user').get(0);
        if (!user) {
            return {
                id: null,
                subscriptionStatus: undefined
            };
        }
        return user.dataset;
    }
    static pageVisited({ pageName = 'default_2', data = {} }) {
        // zaraz not implemented this method
        return;
    }
    static emit(fn, params) {
        this[fn](params);
    }
    static event({ eventName = 'default_1', data = {} }) {
        // zaraz not implemented this method
        return;
    }
    static send(key, params) {
        this.identify();
    }
}
ZarazIntegration.integrationName = 'zaraz';
ZarazIntegration.enabled = true;
ZarazIntegration.ready = false;
ZarazIntegration.retry = 0;


;// CONCATENATED MODULE: ./utils/trackers/user/index.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function user_extends() {
    user_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return user_extends.apply(this, arguments);
}
var _UserTracker;

// import IterableIntegration from './iterable_integration';



window.UserTracker = (_UserTracker = class UserTracker {
    static get queue() {
        return UserTracker._queue;
    }
    static set queue(v) {
        UserTracker._queue.push(v);
    }
    static emit(what = 'event', params = {}) {
        var _this = this;
        return _async_to_generator(function*() {
            _this.queue = {
                fn: what,
                params: user_extends({
                    id: Math.random().toString(36).substring(7)
                }, params)
            };
            return _this.process();
        })();
    }
    static process() {
        var _this = this;
        return _async_to_generator(function*() {
            if (!_this.tracking || !_this.ensure() || _this.debug || _this.queue.length === 0) {
                return;
            }
            _this.run();
        })();
    }
    static identify(extraParams = {}) {
        this.integrations.forEach((klass)=>{
            if (klass.enabled === false) {
                return;
            }
            if ('identify' in klass) {
                klass.identify(extraParams);
            }
        });
    }
    static get customParams() {
        const qs = query_string/* default.getQueryStringData */.Z.getQueryStringData();
        const source = {
            source_project: gon.source_project,
            request_path: gon.request_path
        };
        for(const key in qs){
            if (!this.smartTracking.includes(key)) {
                delete qs[key];
            }
        }
        return user_extends({}, qs, source);
    }
    static run() {
        this.queue.forEach((element)=>{
            this.integrations.forEach((klass)=>{
                if (klass.enabled === false) {
                    return;
                }
                if (Array.isArray(element.params.except) && element.params.except.includes(klass.integrationName)) {
                    return;
                }
                if (Array.isArray(element.params.only) && !element.params.only.includes(klass.integrationName)) {
                    return;
                }
                const params = user_extends({}, element.params, {
                    data: user_extends({}, element.params.data, this.customParams)
                });
                klass.emit(element.fn, params);
            });
            this._queue = this.queue.filter((item)=>item.params.id !== element.params.id);
        });
    }
    static ensure(error = false) {
        for (const klass of this.integrations){
            if (klass.enabled && klass.retry >= 2) {
                // Rollbar.error(
                //   `Turning UserTracker off for class ${klass.integrationName} after 2 attempts`
                // );
                klass.enabled = false;
            } else if (klass.enabled) {
                if (!klass.setup()) {
                    error = true;
                    klass.retry++;
                }
            }
        }
        return !error;
    }
}, _UserTracker._queue = [], _UserTracker.tracking = true, _UserTracker.debug = false, _UserTracker.smartTracking = [
    'qtm_campaign',
    'qtm_content',
    'qtm_medium',
    'qtm_source',
    'qtm_term'
], _UserTracker.integrations = [
    UserIntegration,
    AmplitudeIntegration,
    // IterableIntegration,
    ZarazIntegration
], _UserTracker);
window.jQuery(document).on('userDotCom:loaded', ()=>{
    window.UserTracker.process();
});
document.addEventListener('turbolinks:render', ()=>{
    window.UserTracker.process();
});
(self || window).UserTrackerWorker = false;
(()=>{
    if ((self || window).UserTrackerWorker) {
        return;
    }
    setInterval(()=>{
        window.UserTracker.process();
        (self || window).UserTrackerWorker = true;
    }, 2000);
})();


/***/ }),

/***/ 19394:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* eslint-disable no-console */ class Zaraz {
    static enqueue(method, args) {
        if (this.isScriptLoaded) {
            window.zaraz[method](...args);
        } else {
            if (window.RAILS_ENV === 'development') {
                console.log(`Zaraz (Dev): ${method}`, args);
            }
            this.queue.push([
                method,
                args
            ]);
        }
    }
    static ecommerce(event, payload) {
        this.enqueue('ecommerce', [
            event,
            payload
        ]);
    }
    static track(event, payload) {
        this.enqueue('track', [
            event,
            payload
        ]);
    }
    static set(prop, value, params = {}) {
        this.enqueue('set', [
            prop,
            value,
            params
        ]);
    }
    static setContentGroup() {
        window.zaraz.set('content_group', gon.current_path, {
            scope: 'page'
        });
    }
    static start() {
        const intervalId = setInterval(()=>{
            if (!window.zaraz) {
                return;
            }
            Zaraz.isScriptLoaded = true;
            clearInterval(intervalId);
            this.setContentGroup();
            document.addEventListener('turbolinks:load', ()=>{
                this.setContentGroup();
            });
            this.queue.forEach(([method, args])=>{
                window.zaraz[method](...args);
            });
        }, 1000);
    }
}
Zaraz.isScriptLoaded = false;
Zaraz.queue = [];
if (window.RAILS_ENV !== 'development') {
    Zaraz.start();
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Zaraz);


/***/ })

}]);